var _defs, _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSospese = function SvgSospese(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    "data-name": "Livello 1",
    viewBox: "0 0 100 100",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "bg",
    d: "M50,99.5h0A49.5,49.5,0,0,1,.5,50h0A49.5,49.5,0,0,1,50,.5h0A49.5,49.5,0,0,1,99.5,50h0A49.5,49.5,0,0,1,50,99.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M75.41,39.22a28,28,0,0,0-5.87-8.83,27.62,27.62,0,0,0-8.81-5.89,27.27,27.27,0,0,0-21.46,0,27.62,27.62,0,0,0-8.81,5.89,28,28,0,0,0-5.87,8.83,27.49,27.49,0,0,0,0,21.55,28,28,0,0,0,5.87,8.84,27.62,27.62,0,0,0,8.81,5.89,27.27,27.27,0,0,0,21.46,0,27.62,27.62,0,0,0,8.81-5.89,28,28,0,0,0,5.87-8.84,27.49,27.49,0,0,0,0-21.55ZM33.64,60.73A19.67,19.67,0,0,1,40.19,33,19.08,19.08,0,0,1,50,30.35a18.85,18.85,0,0,1,10.78,3.28ZM68,57.62a19.54,19.54,0,0,1-4.17,6.27,19.84,19.84,0,0,1-6.24,4.19A19,19,0,0,1,50,69.64a19.27,19.27,0,0,1-10.68-3.19L66.43,39.38A19.09,19.09,0,0,1,69.55,50,19.39,19.39,0,0,1,68,57.62Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSospese, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sospese.626eed32.svg";
export { ForwardRef as ReactComponent };